export enum SendToMandateStatus {
  INIT = 'INIT',

  DONE = 'DONE',

  FAIL = 'FAIL',
}
